<template>
  <b-form>
    <b-form-group>
      <template slot="label">
        {{ $t('message.adminContractPartnerDetails.label.name') }}
        <span class="text-danger">*</span>
      </template>
      <b-form-input
        class="rounded-0"
        v-model.trim="contractPartnerName">
      </b-form-input>
    </b-form-group>
    <b-form-group>
      <template slot="label">
        {{ $t('message.adminContractPartnerDetails.label.email') }}
      </template>
      <b-form-input
        class="rounded-0"
        v-model.trim="email">
      </b-form-input>
    </b-form-group>
    <b-form-group>
      <template slot="label">
        {{ $t('message.adminContractPartnerDetails.label.domain') }}
      </template>
      <b-form-input
        class="rounded-0"
        v-model.trim="domain">
      </b-form-input>
    </b-form-group>
    <b-form-group>
      <template slot="label">
        {{ $t('message.adminContractPartnerDetails.label.street') }}
      </template>
      <b-form-input
        class="rounded-0"
        v-model.trim="street">
      </b-form-input>
    </b-form-group>
    <b-form-group>
      <template slot="label">
        {{ $t('message.adminContractPartnerDetails.label.streetNumber') }}
      </template>
      <b-form-input
        class="rounded-0"
        v-model.trim="streetNumber">
      </b-form-input>
    </b-form-group>
    <b-form-group>
      <template slot="label">
        {{ $t('message.adminContractPartnerDetails.label.postalCode') }}
      </template>
      <b-form-input
        class="rounded-0"
        v-model.trim="postalCode">
      </b-form-input>
    </b-form-group>
    <b-form-group>
      <template slot="label">
        {{ $t('message.adminContractPartnerDetails.label.postOfficeBox') }}
      </template>
      <b-form-input
        class="rounded-0"
        v-model.trim="postOfficeBox">
      </b-form-input>
    </b-form-group>
    <b-form-row class="mt-5">
      <b-col>
        <b-btn
          class="rounded-0 px-0"
          variant="link"
          @click="$emit('onCancel')">
          {{ $t('message.adminContractPartnerDetails.btn.back') }}
        </b-btn>
      </b-col>
      <b-col>
        <div class="d-flex flex-row">
          <div class="ml-auto">
            <b-btn
              v-if="isDeletable"
              variant="danger"
              @click="$emit('onDelete')">
              {{ $t('message.adminContractPartnerDetails.btn.delete') }}
            </b-btn>
            <b-btn
              class="ml-4"
              variant="primary"
              @click="$emit('onSave')">
              {{ $t('message.adminContractPartnerDetails.btn.save') }}
            </b-btn>
          </div>
        </div>
      </b-col>
    </b-form-row>
  </b-form>
</template>

<script>
  export default {
    name: 'AdminContractPartnerForm',
    computed: {
      contractPartner () {
        return this.$store.getters.adminContractPartner
      },
      isDeletable () {
        const isDeletable = Object.keys(this.contractPartner).find(key => key === 'isDeletable')
        if (isDeletable && this.contractPartner.isDeletable) {
          return true
        }
        return false
      },
      city: {
        get () {
          return this.contractPartner.city
        },
        set (city) {
          this.$store.commit('updateAdminContractPartnerCity', city)
        }
      },
      contractPartnerName: {
        get () {
          return this.contractPartner.contractPartnerName
        },
        set (contractPartnerName) {
          this.$store.commit('updateAdminContractPartnerName', contractPartnerName)
        }
      },
      country: {
        get () {
          return this.contractPartner.country
        },
        set (country) {
          this.$store.commit('updateAdminContractPartnerCountry', country)
        }
      },
      domain: {
        get () {
          return this.contractPartner.domain
        },
        set (domain) {
          this.$store.commit('updateAdminContractPartnerDomain', domain)
        }
      },
      email: {
        get () {
          return this.contractPartner.email
        },
        set (email) {
          this.$store.commit('updateAdminContractPartnerEmail', email)
        }
      },
      street: {
        get () {
          return this.contractPartner.street
        },
        set (street) {
          this.$store.commit('updateAdminContractPartnerStreet', street)
        }
      },
      streetNumber: {
        get () {
          return this.contractPartner.streetNumber
        },
        set (streetNumber) {
          this.$store.commit('updateAdminContractPartnerStreetNumber', streetNumber)
        }
      },
      postOfficeBox: {
        get () {
          return this.contractPartner.postOfficeBox
        },
        set (postOfficeBox) {
          this.$store.commit('updateAdminContractPartnerPostOfficeBox', postOfficeBox)
        }
      },
      postalCode: {
        get () {
          return this.contractPartner.postalCode
        },
        set (postalCode) {
          this.$store.commit('updateAdminContractPartnerPostalCode', postalCode)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/AdminContractPartnerForm.vue